module.exports = __webpack_public_path__ + "static/images/applecard.f110f61.png";